import { createElement as rc } from 'react';
import LeftSideNavAppLayout from './LeftSideNavAppLayout';

function NoNavAppLayout(props) {
    return rc(LeftSideNavAppLayout, { ...props, excludeSideBar: true });
}

export default NoNavAppLayout;
